module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.type === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('div', [_c('el-button', {
    on: {
      "click": _vm.addSolution
    }
  }, [_vm._v("新增解题过程")])], 1), _vm._v(" "), _c('solution-table', {
    attrs: {
      "tableData": _vm.solutionList
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a82b2c62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solutionTableFatherDlg/src/main.vue
// module id = 652
// module chunks = 2